module.exports = __webpack_public_path__ + "img/pasta_a_la_vodka_sauce.f6aa3c39.jpg";